import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default () => {
  const sections = document.querySelectorAll('.js-header-light');
  const sectionsSplitted = document.querySelectorAll('.js-header-splitted');
  const header = document.querySelector('.header');
  const HEADER_LIGHT = 'header--light';
  const HEADER_SPLITTED = 'header--splitted';
  const homeHero = document.querySelector('.home-hero');

  changeColorAt(sections, HEADER_LIGHT);
  changeColorAt(sectionsSplitted, HEADER_SPLITTED);

  function changeColorAt(sections, className) {
    if (sections.length) {
      sections.forEach(function(section) {
        ScrollTrigger.create({
          trigger: section,
          start: 'top 1px',
          end: 'bottom top',
          onEnter: (e) => {
            header.classList.add(className);
          },
          onEnterBack: () => {
            header.classList.add(className);
          },
          onLeave: () => {
            header.classList.remove(className);
          },
          onLeaveBack: () => {
            header.classList.remove(className);
          },
        });
      });
    }
  }

  // add special case to fix homepage scrolltrigger issues
  if (homeHero) {
    header.classList.add(HEADER_LIGHT);

    ScrollTrigger.create({
      trigger: homeHero,
      start: 'top top',
      end: 'bottom 50px',
      onEnterBack: () => {
        header.classList.add(HEADER_LIGHT);
      },
      onLeave: () => {
        header.classList.remove(HEADER_LIGHT);
      },
    });
  }
}